import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { DatasetDropdownProps, Country } from "./DatasetDropdown-interface";
import "./DatasetDropdown.scss";

const DatasetDropdownHome = ({
  value,
  onChange,
  disabled,
  countries = [],
}: DatasetDropdownProps) => {
  const [internalValue, setInternalValue] = useState<string>("");

  // Set default selected country
  useEffect(() => {
    if (countries.length > 0) {
      const defaultVal = value || countries[0].code; // first country's code if value is empty
      setInternalValue(defaultVal);
      if (!value) {
        onChange?.({ target: { value: defaultVal } } as any);
      }
    }
  }, [value, countries, onChange]);

  const handleChange = (event: SelectChangeEvent) => {
    setInternalValue(event.target.value);
    onChange?.(event);
  };

  if (countries.length === 0) {
    return <div>No available countries</div>;
  }

  return (
    <FormControl fullWidth disabled={disabled}>
      <Select
        value={internalValue}
        onChange={handleChange}
        displayEmpty
        MenuProps={{
          MenuListProps: {
            className: "dataset-dropdown-list",
          },
          PaperProps: {
            className: "dataset-dropdown",
          },
        }}
      >
        {countries.map((country: Country) => (
          <MenuItem key={country.code} value={country.code} className="dataset-dropdown-item">
            {country.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DatasetDropdownHome;
